export const COLUMNS_REPORTE_EMBARQUE_SECTOR_3_LINEA_7 = [
  {
    name: 'silo',
    label: 'Silo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'etiqueta',
    label: 'Condición',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'fechaInicioLlenado',
    label: 'Ensilado',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Toneladas',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'vejezSilo',
    label: 'Vejez [días]',
    options: {
      filter: true,
      sort: true
    }
  }
]
export const COLUMNS_REPORTE_EMBARQUE_SECTOR_3_LINEA_7_TO_PRINT = [
  {
    name: 'silo',
    label: 'Silo',
    width: 40,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'etiqueta',
    label: 'Etiqueta',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'fechaInicioLlenado',
    label: 'Fecha De LLenado',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Peso Neto Base Vigente',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'vejezSilo',
    label: 'Vejez',
    width: 60,
    mantenerCase: true
  }
]
